import { TriggerConnection } from '@/services/triggers/types';

/** Statuses from which the connection can actually reach the provider. */
const USABLE_STATUSES = new Set(['configured', 'active']);

/**
 * Whether this connection has a grant we can use right now.
 *
 * Shared by the connect flow, the connection card and the workflow section so
 * "usable" cannot come to mean three different things. Anything else — awaiting
 * consent, expired, degraded, paused — needs authorizing again before a folder
 * can be watched.
 */
export const isConnectionUsable = (c: TriggerConnection) =>
  USABLE_STATUSES.has(c.status);

/**
 * Whether consent has finished, one way or the other.
 *
 * Deliberately stricter than "not pending_auth": a re-auth leaves the working
 * grant and its status in place and parks the new account under
 * `pending_connected_account_id`, so the parked key clearing is what marks the
 * new grant as adopted. Requiring a usable status as well means a connection
 * that is expired or degraded is never mistaken for a completed consent.
 */
export const isConsentSettled = (c: TriggerConnection) =>
  isConnectionUsable(c) && !c.config?.pending_connected_account_id;
